import { getAuthToken } from "./authorize.js";

export const fetchData = async ({ url, clientId, clientSecret }) => {
    try {
        const token = await getAuthToken({
            clientId,
            clientSecret,
            tokenUrl: "/o/oauth2/token",
        });

        if (!token) {
            console.error("No se pudo obtener el token.");
            return { items: [] };
        }
        
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`Error en fetchData: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error en fetchData:", error);
        return { items: [] };
    }
};

export const getEmpresas = async (config, searchTerm = '') => {
    const { clientId, clientSecret } = config;
    
    let optimizedUrl = `/o/c/simuladorlibranzaempresases/?fields=id,idEmpresa,nombreEmpresa&restrictFields=actions,facets,lastPage,page,pageSize,totalCount`;
    
    if (searchTerm && searchTerm.trim().length > 0) {
        const term = searchTerm.trim();
        const upperTerm = term.toUpperCase();
        optimizedUrl += `&filter=contains(nombreEmpresa,'${encodeURIComponent(upperTerm)}')`;
    }

    const data = await fetchData({
        url: optimizedUrl,
        clientId,
        clientSecret,
    });

    return Array.isArray(data) ? data : data.items || [];
};


export const getConvenios = async (config, empresaId) => {
    const { clientId, clientSecret } = config;

    if (!empresaId) return [];

    const baseUrl = `/o/c/simuladorlibranzaconvenioses/?fields=id,idConvenio,tipoConvenio,diasLibranza,activo,r_empresasConvenios_c_simuladorLibranzaEmpresasId&restrictFields=actions,facets,lastPage,page,pageSize,totalCount`;

    const filter = `filter=r_empresasConvenios_c_simuladorLibranzaEmpresasId eq '${empresaId}' and activo eq true`;

    const optimizedUrl = `${baseUrl}&${filter}`;

    const data = await fetchData({
        url: optimizedUrl,
        clientId,
        clientSecret,
    });

    return data.items || [];
};


export const getTasasByConvenio = async (config, convenioId, plazoKey) => {
    const { clientId, clientSecret } = config;

    if (!convenioId) return [];

    const baseUrl = `/o/c/simuladorlibranzatasases/?fields=tasa,plazo,r_conveniosTasas_c_simuladorLibranzaConveniosId&restrictFields=actions,facets,lastPage,page,pageSize,totalCount`;

    const filter = `filter=r_conveniosTasas_c_simuladorLibranzaConveniosId eq '${convenioId}' and plazo eq '${plazoKey}'`;

    const optimizedUrl = `${baseUrl}&${filter}`;

    const data = await fetchData({
        url: optimizedUrl,
        clientId,
        clientSecret,
    });

    const allTasas = data.items || [];

    const plazoNum = parseInt(plazoKey);

    return allTasas.filter((t) => {
        const matchPlazo = t.plazo === plazoNum || t.plazo?.key === plazoNum || t.plazo?.key === plazoKey;
        return matchPlazo;
    });
};

export const getPlazosMontos = async (config) => {
    const { clientId, clientSecret } = config;
    
    const optimizedUrl = `/o/c/plazosmontolibranzas/?fields=valorMinimo,valorMximo,plazoMinimo,plazoMaximo&restrictFields=actions,facets,lastPage,page,pageSize,totalCount`;

    const data = await fetchData({
        url: optimizedUrl,
        clientId,
        clientSecret,
    });

    return data.items || [];
};